export class WarrantyListQuery {
    constructor(public ChkDate?, public FromDate?, public ToDate?, public OptionValue?, public ScID?, public DID?) { }
}